export const STORAGE_KEY = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  USER_ID: "userId",
  HIDE_DOUBLE_POINT_EVENT: "hideDoublePointEvent",
};
